import React from "react";
import { Route, Routes } from "react-router-dom";
import CampaignsList from "./campaigns";
import AddCampaign from "./campaigns/add-campaign";
import EditCampaign from "./campaigns/edit-campaign";
import CampaignDetail from "./campaigns/campaign-detail";
import UTMTool from "./utm-tool/UTMTool";

const Marketing = () => {
  return (
    <Routes>
      <Route path="/add-campaign" element={<AddCampaign />} />
      <Route path="/edit-campaign/:id" element={<EditCampaign />} />
      <Route path="/campaign/:id" element={<CampaignDetail />} />
      <Route path="/campaigns" element={<CampaignsList />} />
      <Route path="/utm-tool" element={<UTMTool />} />
    </Routes>
  );
};

export default Marketing;
